/* UploadImageDropRenderer.js */

"use strict";
const InputFileControl = require("@gluenetworks/steve_ui_core").Control.Action.InputFile;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

const _ = require("lodash");

class UploadImageDropRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("import-screen-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._importScreen = document.createElement("div");
        this._importScreen.setAttribute("type", "text");
        this._importScreen.setAttribute("draggable", true);

        this._titleText = document.createElement("h3");
        this._titleText.innerHTML = "Drop Image to Upload";

        this._buttonBarElem = document.createElement("div");
        this._buttonBarElem.classList.add("button-bar");

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });

        this._importFromFile = new InputFileControl({
            id: "fileExplorerFileUploadControl",
            label: "Upload Image",
            acceptFiles: "*",
            darkTheme: true,
            multiple: false,
        });

        this._importFromFile.setAttribute("style", "margin-right:15px;");

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._importScreen.addEventListener(
            "drop",
            (this._onDropFromFile = this._onDropFromFile.bind(this))
        );
        this._importScreen.addEventListener(
            "dragover",
            (this._onDragover = this._onDragover.bind(this))
        );
        this._importFromFile.on(
            "FileHandle",
            (this._onImportFromFile = this._onImportFromFile.bind(this))
        );
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._importScreen.removeEventListener("drop", this._onDropFromFile);
        this._importScreen.removeEventListener("dragover", this._onDragover);
        this._importFromFile.removeListener("FileHandle", this._onImportFromFile);
        this._cancelButton.removeAllListeners("UserClick");
    }

    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            if (!_.isEmpty(this._nameField.getValue())) {
                this._callCreateDevice();
            }
        }
    }

    checkValue(value) {
        this._confirmButton.disabled = _.isEmpty(value) || value.trim().length === 0;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._cancelButton.shutdown(), this._importFromFile.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._importFromFile = undefined;
                this._cancelButton = undefined;
                this._titleText.remove();
                this._titleText = undefined;
                this._importScreen.remove();
                this._importScreen = undefined;
                this._logger = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._importScreen);
                this._importScreen.appendChild(this._titleText);
                this._rootElem.appendChild(this._buttonBarElem);
                this._buttonBarElem.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonBarElem.appendChild(this._importFromFile.renderer.rootElement);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onImportFromFile(event) {
        event.preventDefault();
        this._model.importFile(event.target.files);
    }

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onDropFromFile(event) {
        event.preventDefault();
        this._model.importFile(event.dataTransfer.files);
    }

    _onDragover(event) {
        event.preventDefault();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = UploadImageDropRenderer;
